import './Logo.sass'

import Box, { BoxProps } from '@mui/material/Box'

import React from 'react'
import logo from '../../../assets/img/logo/logo_BKBN_black.svg'
import logo_white from '../../../assets/img/logo/logo_BKBN_white.svg'

/**
 * @interface Props Input properties
 */
export interface Props extends BoxProps {
  /** Color of the logo, default to black */
  type?: 'black' | 'white'
  /** The additional classes to append */
  className?: string
}

/**
 * @component Graphical component containing a logo image
 * @example
 * <Logo type="black" className="class" />
 */
const Logo: React.FC<Props> = ({
  type = 'black',
  className = '',
  ...boxProps
}) => {

  let logoImg = logo
  if (type === 'white') logoImg = logo_white

  return (
    <Box className={`logo ${className}`} {...boxProps}>
      <img src={logoImg} alt="Logo" />
    </Box>
  )
}

export default Logo
